interface WarehouseBackdropProps {
  className?: string;
}

/**
 * Decorative, low-opacity animated backdrop (scattered warehouse glyphs
 * gently floating/rotating) meant to sit behind a foreground card. Pure
 * inline SVG/CSS — no external image/video asset required.
 */
export default function WarehouseBackdrop({ className = '' }: WarehouseBackdropProps) {
  return (
    <svg
      viewBox="0 0 600 600"
      preserveAspectRatio="xMidYMid slice"
      className={className}
      aria-hidden="true"
    >
      {/* pallet box */}
      <g className="wh-float-a" style={{ transformOrigin: '90px 110px' }}>
        <rect x="60" y="80" width="60" height="60" rx="8" fill="none" stroke="#1e3a5f" strokeOpacity="0.16" strokeWidth="6" />
        <line x1="60" y1="110" x2="120" y2="110" stroke="#1e3a5f" strokeOpacity="0.16" strokeWidth="6" />
      </g>

      {/* stacked crates */}
      <g className="wh-float-b" style={{ transformOrigin: '500px 140px' }}>
        <rect x="470" y="120" width="46" height="40" rx="6" fill="none" stroke="#d97706" strokeOpacity="0.18" strokeWidth="5" />
        <rect x="470" y="70" width="46" height="40" rx="6" fill="none" stroke="#f59e0b" strokeOpacity="0.18" strokeWidth="5" />
      </g>

      {/* forklift outline */}
      <g className="wh-float-c" style={{ transformOrigin: '110px 470px' }}>
        <rect x="70" y="450" width="70" height="42" rx="6" fill="none" stroke="#1e3a5f" strokeOpacity="0.14" strokeWidth="6" />
        <line x1="140" y1="430" x2="140" y2="492" stroke="#1e3a5f" strokeOpacity="0.14" strokeWidth="6" />
        <circle cx="88" cy="500" r="12" fill="none" stroke="#1e3a5f" strokeOpacity="0.14" strokeWidth="6" />
        <circle cx="128" cy="500" r="12" fill="none" stroke="#1e3a5f" strokeOpacity="0.14" strokeWidth="6" />
      </g>

      {/* pallet stack */}
      <g className="wh-float-d" style={{ transformOrigin: '480px 470px' }}>
        <rect x="440" y="450" width="80" height="16" rx="3" fill="none" stroke="#f59e0b" strokeOpacity="0.16" strokeWidth="5" />
        <rect x="440" y="475" width="80" height="16" rx="3" fill="none" stroke="#f59e0b" strokeOpacity="0.16" strokeWidth="5" />
      </g>

      {/* delivery truck outline */}
      <g className="wh-float-e" style={{ transformOrigin: '300px 300px' }}>
        <rect x="250" y="280" width="90" height="50" rx="8" fill="none" stroke="#1e3a5f" strokeOpacity="0.10" strokeWidth="6" />
        <rect x="340" y="298" width="34" height="32" rx="6" fill="none" stroke="#1e3a5f" strokeOpacity="0.10" strokeWidth="6" />
        <circle cx="275" cy="336" r="10" fill="none" stroke="#1e3a5f" strokeOpacity="0.10" strokeWidth="6" />
        <circle cx="345" cy="336" r="10" fill="none" stroke="#1e3a5f" strokeOpacity="0.10" strokeWidth="6" />
      </g>

      {/* small amber accent dot cluster */}
      <circle className="wh-float-a" cx="200" cy="230" r="5" fill="#f59e0b" fillOpacity="0.35" />
      <circle className="wh-float-b" cx="420" cy="230" r="4" fill="#1e3a5f" fillOpacity="0.25" />
      <circle className="wh-float-c" cx="330" cy="130" r="4" fill="#f59e0b" fillOpacity="0.3" />
    </svg>
  );
}
